import { Injectable } from "@angular/core";
import { Router } from '@angular/router'
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from "src/environments/environment";
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
const MINUTES_UNITL_AUTO_LOGOUT = 30 // in mins
const CHECK_INTERVAL = 30000 // in ms
const STORE_KEY =  'lastAction';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {
 public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
 public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
  private helper = new JwtHelperService();
  constructor(private router: Router, private authenticationService: AuthenticationService) {

    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(STORE_KEY,Date.now().toString());
  }

  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover',()=> this.reset());
    document.body.addEventListener('mouseout',() => this.reset());
    document.body.addEventListener('keydown',() => this.reset());
    document.body.addEventListener('keyup',() => this.reset());
    document.body.addEventListener('keypress',() => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    var isTimeout = diff < 0;
    console.log("isTimeout= "+ isTimeout);
    if (isTimeout)  {
    //  localStorage.clear();
      console.log("isTimeout11= "+ isTimeout);
      isTimeout=false;
      sessionStorage.removeItem('historyNavigation');
      this.authenticationService.logout();
      localStorage.clear();
      window.location.href = environment.domainLoginPortal;
     // this.router.navigate([environment.domainLoginPortal]);
    }
  }
}
